// extracted by mini-css-extract-plugin
module.exports = {"line-right-arrow":"_2rcZA","line-right-arrow-fill":"b_qph"};